import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Component from "./editable-component.js";
import {media, colors} from "./theme.js";
import {Title, Text} from "./typo.js";
import Image from "./image.js";
import {Mail, Phone, SmartPhone} from "./icons.js";
import Stack from "./stack.js";
import PageNewsletter from "./page-newsletter.js";
export default function ContactPage(props) {
  const {headline, contact_image, content = []} = props;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Component, {
    ...props
  }, /* @__PURE__ */ React.createElement(TitleContainer, {
    level: 2
  }, headline), /* @__PURE__ */ React.createElement(LayoutContainer, null, /* @__PURE__ */ React.createElement(Columns, {
    content
  }), contact_image && /* @__PURE__ */ React.createElement(ContactImage, {
    ...contact_image
  }))));
}
function Columns(props) {
  const {content} = props;
  return /* @__PURE__ */ React.createElement(ColumnsContainer, null, content.map((m) => /* @__PURE__ */ React.createElement(Column, {
    key: m._uid,
    ...m
  })));
}
function Column(props) {
  if (props.component === "page_newsletter") {
    return /* @__PURE__ */ React.createElement(PageNewsletter, {
      ...props
    });
  }
  const {content, headline} = props;
  return /* @__PURE__ */ React.createElement(ColumnContainer, {
    ...props
  }, headline && /* @__PURE__ */ React.createElement(ColumnTitle, {
    level: 5
  }, headline), /* @__PURE__ */ React.createElement(Items, null, content.map((m) => /* @__PURE__ */ React.createElement(Item, {
    key: m._uid,
    ...m
  }))));
}
function Item(props) {
  if (props.component === "contact_email") {
    return /* @__PURE__ */ React.createElement(ContactItemContainer, {
      ...props,
      key: props._uid
    }, /* @__PURE__ */ React.createElement(ContactItem, null, /* @__PURE__ */ React.createElement(Mail, null), /* @__PURE__ */ React.createElement(ContactEmail, {
      href: `mailto:${props.email}`
    }, props.email)));
  }
  if (props.component === "contact_phone") {
    return /* @__PURE__ */ React.createElement(ContactItemContainer, {
      ...props,
      key: props._uid
    }, /* @__PURE__ */ React.createElement(ContactItem, null, /* @__PURE__ */ React.createElement(Phone, null), /* @__PURE__ */ React.createElement(ContactEmail, {
      href: `tel:${props.number}`
    }, props.number)));
  }
  if (props.component === "contact_mobile") {
    return /* @__PURE__ */ React.createElement(ContactItemContainer, {
      ...props,
      key: props._uid
    }, /* @__PURE__ */ React.createElement(ContactItem, null, /* @__PURE__ */ React.createElement(SmartPhone, null), /* @__PURE__ */ React.createElement(ContactEmail, {
      href: `tel:${props.number}`
    }, props.number)));
  }
  return /* @__PURE__ */ React.createElement(ContactItemContainer, {
    ...props,
    key: props._uid
  }, /* @__PURE__ */ React.createElement(Address, null, props.address));
}
const Container = styled.div`
  padding-top: 80px;
  margin: auto;
  padding-left: 0;
  padding-right: 0;

  ${media.mobile} {
    padding-top: 32px;
  }
`;
const ContactEmail = styled.a`
  color: ${colors.b};
  font-size: 14px;

  ${media.mobile} {
    font-size: 16px;
  }
`;
const LayoutContainer = styled.div`
  display: grid;
  grid-gap: 36px;
  grid-template-columns: 300px 1fr;
  margin: 36px 0;

  ${media.phone} {
    grid-template-columns: 1fr;
  }
`;
const ContactItemContainer = styled(Component)``;
const ColumnsContainer = styled.div`
  // grid-auto-flow: row;
  // grid-gap: 24px;

  ${media.mobile} {
    display: grid;
    grid-auto-flow: row;
    margin: 40px 0;
  }
`;
const ColumnContainer = styled.div`
  margin-top: 32px;
`;
const Items = styled(Stack)`
  --spacing: 4px;

  svg {
    max-width: 16px;
    max-height: 16px;
    margin-right: 8px;

    & + a {
      font-weight: bold;
    }
  }

  // ${media.mobile} {
  //   --spacing: 16px;
  //   svg {
  //     max-width: 24px;
  //     max-height: 24px;
  //   }
  // }
`;
const ContactItem = styled(Text)`
  display: flex;
  align-items: center;
  font-size: 14px;

  ${media.mobile} {
    font-size: 16px;
  }
`;
const Address = styled(Text)`
  font-size: 14px;
  white-space: break-spaces;
  line-height: 22px;

  ${media.mobile} {
    font-size: 16px;
  }
`;
const ColumnTitle = styled(Title)`
  margin-bottom: 12px;

  ${media.mobile} {
    margin-bottom: 8px;
  }
`;
const TitleContainer = styled(Title)`
  ${media.mobile} {
    font-size: 30px;
  }
`;
const ContactImage = styled(Image)`
  width: 100%;

  ${media.mobile} {
    max-width: 100%;
  }
`;
